var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_131_2994",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_131_2994",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAB7ElEQVR4Ae3ag66cQRyG8W5t27Zt21ZQ23Y7cfZ29j7OZZRXUE+fJAf/TDp7sPxm3zf5HfNZo1tZpmmjMQRJz3fQYvRGUpvQiQAOr3EEU5BD5nexkwGsh9iG4cjkZsHBG+G8cRcu4hKWow8ysRxudioAYxNxEC8iId7gBGagO+p2i+E6GcCuJxbgPN5HYjzGToxCXa0nHpYYwG4g1uEWXMQ1rEJ/1Hxr4Zo9L0MAu7HYi2eREO9wGnPQA1VfHzyHa7a2jAHsemAOzuBdJMYzEItoVdz24GKsZ4UC2PXDalyDi7iFdRiIim0g3sA1WwxW8QB2o7ATjyMh3uM8FqAnyrqDQfFclQPYdccMnDAHSuglDmAiSt6I4OJqFljNAtj1wXJcgou4i02l3DDziRnd6AEGN3YAVkKAzE4BDAXQeYACKEDyc0a5pwAKUIMbQwqgAAqgAAqgACUs/QAKoADdcRYFfMKP5tcFnEX3lANMQxN8EU2YlmKAafgG3wHfMC2lAN2DQ/438liBgc2v8/gdHBO6pxLgbPDPb8X/tjWIcDaVAAX4ZnkUW958bSGVAJ/gm61Asa0wX/splQA/4JsNRLENMl/7Q8cAnQfoUkDXA3RNULcFdGswpQDlnwIogAIogAI02DM2FEABNE37B31bWr4sy5sTAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService9);
export default __webpack_public_path__ + "static/media/service9.b8d506550b60272a8f3d09217372cd44.svg";
export { ForwardRef as ReactComponent };